
const chainConfig = {
    11155111: {
        chain: 'Seploia',
        key: 'Seploia',
        explorer: 'https://etherscan.io',
        name: "Sepolia",
        id: 11155111
       
    }
  
};

export default chainConfig;